import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import { defineComponent, ref, onMounted, onUnmounted } from 'vue';
import { Loader } from '@googlemaps/js-api-loader';
import ButtonBasic from './form/ButtonBasic.vue';
var loader = new Loader({
  apiKey: "AIzaSyA-uygSAdwkYDXGcbrVK60iEuV2DpMdcto",
  version: 'weekly',
  libraries: ['places', 'marker']
});
export default defineComponent({
  components: {
    ButtonBasic: ButtonBasic
  },
  setup: function setup() {
    var _this = this;
    var searchWordExample = ref('Find'); // Create a ref for your local variable

    // Define the onMounted lifecycle hook
    onMounted(function () {
      var index = 0;
      var words = ['Find', 'Show me', 'Locate'];
      var changeExampleWord = function changeExampleWord() {
        searchWordExample.value = words[index % words.length];
        index++;
      };

      // Set the interval to change the searchWordExample every second
      setInterval(function () {
        changeExampleWord();
      }, 2000);
    });
    onUnmounted(function () {
      // Clear the interval when the component is unmounted
      try {
        clearInterval(window.interval);
        clearInterval(_this.locationGatheringInterval);
      } catch (error) {
        console.log('error clearing interval', error);
      }
    });
    return {
      searchWordExample: searchWordExample
    };
  },
  name: 'MapComponent',
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('<<<<<<<<< MapComponent mounted >>>>>>>>>');
            _this2.loadMap();
            // try {
            //   const options = {
            //     enableHighAccuracy: true,
            //     timeout: 5000,
            //     maximumAge: 0
            //   };

            //   // heres how we handle success
            //   const success = (position) => {
            //     this.$store.commit('updatePermissions', { permission: 'location', value: true });
            //     console.log('Location data:', position);
            //     this.$store.commit('updateLocation', JSON.stringify(position.coords.latitude + ',' + position.coords.longitude));
            //     this.$store.commit('updateLongLat', { long: position.coords.longitude, lat: position.coords.latitude });
            //   };

            //   // heres how we handle errors
            //   const error = (err) => {
            //     if (err.code === err.PERMISSION_DENIED) {
            //       this.$store.commit('updatePermissions', { permission: 'location', value: 'denied' });
            //     }
            //   };

            //   navigator.geolocation.getCurrentPosition(success, error, options);
            //   this.locationGatheringInterval = setInterval(() => {
            //     const options = {
            //       enableHighAccuracy: true,
            //       timeout: 5000,
            //       maximumAge: 0
            //     };

            //     const success = (position) => {
            //       this.$store.commit('updatePermissions', { permission: 'location', value: true });
            //       console.log('Location data:', position);
            //       this.$store.commit('updateLocation', JSON.stringify(position.coords.latitude + ',' + position.coords.longitude));
            //       this.$store.commit('updateLongLat', { long: position.coords.longitude, lat: position.coords.latitude });

            //     };

            //     const error = (err) => {
            //       if (err.code === err.PERMISSION_DENIED) {
            //         this.$store.commit('updatePermissions', { permission: 'location', value: 'denied' });
            //       }
            //     };

            //     navigator.geolocation.getCurrentPosition(success, error, options);
            //   }, 60000);
            // } catch (error) {
            //    this.$store.commit('updateActivityLogsError', 'error in map component mount '+JSON.stringify(error));

            //   console.error('Error requesting geolocation permission:', error);

            // }

            // if(this.$store.state.permission_location){

            // }
            // make sure interval has not already been set before setting it and use window to make it global
            // if (!window.interval) {

            //   var changeExampleWord = this.flipExampleWord;
            //   window.interval = setInterval(() => {
            //     console.log('flipping');
            //     // change searchWordExample to change looping through the array in order to change the search word using the following words Find, Show, Locate, 
            //     changeExampleWord();
            //   }, 1000);
            // }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  props: {},
  data: function data() {
    return {
      searchLocation: null,
      locationGatheringInterval: null,
      showMapHint: true,
      directionsService: null,
      directionsRenderer: null,
      selectedLocation: null,
      userMarker: null,
      streetView: null,
      marker: null,
      service: null,
      map: null,
      loader: loader,
      radius: '20',
      infowindow: null,
      mapTypeId: 'roadmap',
      //roadmap, hybrid, terrain, satellite
      mapOptions: {
        center: {
          lat: 0,
          lng: 0
        },
        zoom: 13,
        //13
        fullscreenControl: false,
        // Disable the fullscreen control
        zoomControl: true,
        streetViewControl: true // Enable the Street View Pegman control
      }
    };
  },
  watch: {
    '$store.state.locationLat': 'loadMap',
    '$store.state.locationLong': 'loadMap',
    '$store.state.keyword': 'loadMap',
    '$store.state.searchLocations': 'fetchPlaces'
  },
  methods: {
    flipExampleWord: function flipExampleWord() {
      if (this.searchWordExample === 'Find') {
        this.searchWordExample = 'Show';
      } else if (this.searchWordExample === 'Show') {
        this.searchWordExample = 'Locate';
      } else if (this.searchWordExample === 'Locate') {
        this.searchWordExample = 'Find';
      }
    },
    isMobileDevice: function isMobileDevice() {
      return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
    },
    openGoogleMapsDirections: function openGoogleMapsDirections() {
      var origin = "".concat(this.$store.state.locationLat, ",").concat(this.$store.state.locationLong);
      var destination = "".concat(this.selectedLocation.lat(), ",").concat(this.selectedLocation.lng());
      var url = '';
      if (this.isMobileDevice()) {
        url = "geo:".concat(origin, "?q=").concat(destination, "&mode=d"); // 'd' for driving mode
      } else {
        url = "https://www.google.com/maps/dir/?api=1&origin=".concat(this.$store.state.locationLat, ",").concat(this.$store.state.locationLong, "&destination=").concat(this.selectedLocation.lat(), ",").concat(this.selectedLocation.lng(), "&travelmode=driving");
      }
      window.open(url, '_blank');
    },
    navigateToSelectedLocation: function navigateToSelectedLocation() {
      if (this.selectedLocation) {
        this.$refs.startNavigationButton.hidden = false; // Show the start navigation button
        this.$refs.openExternallyButton.hidden = false; // Show the open externally button
      }
    },
    openDirectionsExternally: function openDirectionsExternally() {
      if (this.selectedLocation && this.$store.state.locationLat && this.$store.state.locationLong) {
        var url = "https://www.google.com/maps/dir/?api=1&origin=".concat(this.$store.state.locationLat, ",").concat(this.$store.state.locationLong, "&destination=").concat(this.selectedLocation.lat(), ",").concat(this.selectedLocation.lng(), "&travelmode=driving");
        window.open(url, '_blank');
      }
    },
    startNavigation: function startNavigation() {
      var _this3 = this;
      if (navigator.geolocation) {
        navigator.geolocation.watchPosition(function (position) {
          _this3.$store.commit('updateLongLat', {
            "long": position.coords.latitude,
            lat: position.coords.longitude
          });
          _this3.navigateFromCurrentLocation();
        }, function (error) {
          console.error('Error occurred while watching position:', error);
        }, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        });
      } else {
        alert('Geolocation is not supported by this browser.');
      }
    },
    navigateFromCurrentLocation: function navigateFromCurrentLocation() {
      var _this4 = this;
      if (this.selectedLocation && this.$store.state.locationLat && this.$store.state.locationLong) {
        var start = new window.google.maps.LatLng(this.$store.state.locationLat, this.$store.state.locationLong);
        var end = this.selectedLocation;
        var request = {
          origin: start,
          destination: end,
          travelMode: window.google.maps.TravelMode.DRIVING
        };
        this.directionsService.route(request, function (result, status) {
          if (status === window.google.maps.DirectionsStatus.OK) {
            _this4.directionsRenderer.setDirections(result);
          } else {
            console.error('Directions request failed due to', status);
          }
        });
      }
    },
    loadMap: function loadMap() {
      var _this5 = this;
      console.log('Refreshing Map');
      if (this.$store.state.locationLong && this.$store.state.locationLat) {
        this.mapOptions.center.lat = this.$store.state.locationLat;
        this.mapOptions.center.lng = this.$store.state.locationLong;
        loader.importLibrary('places').then(function (google) {
          _this5.mapOptions.streetViewControlOptions = {
            position: google.maps.ControlPosition.RIGHT_TOP
          };
          _this5.mapOptions.zoomControlOptions = {
            position: google.maps.ControlPosition.LEFT_CENTER
          };
          _this5.mapOptions.mapTypeId = _this5.mapTypeId;
          _this5.map = new google.maps.Map(document.getElementById('map'), _this5.mapOptions);
          _this5.userMarker = new google.maps.Marker({
            position: _this5.mapOptions.center,
            map: _this5.map,
            icon: {
              url: 'https://fonts.gstatic.com/s/i/materialicons/star/v6/24px.svg',
              // Material Design "place" icon
              scaledSize: new google.maps.Size(32, 32),
              // Resize the icon
              // change color of icon to yellow
              fillColor: '#FFD700',
              fillOpacity: 1,
              strokeWeight: 0,
              // add a label to the icon
              labelOrigin: new google.maps.Point(16, 16)
            },
            zIndex: 1000 // Set a high zIndex to make sure the user marker stays on top of other markers
          });
          _this5.infowindow = new google.maps.InfoWindow();

          //   this.streetView = new google.maps.StreetViewPanorama(document.getElementById('map'), {
          //   fullscreenControl: false, // Disable the fullscreen control for Street View
          // });

          // this.map.setStreetView(this.streetView);

          try {
            _this5.map.getStreetView().addListener('visible_changed', function () {
              if (_this5.map.getStreetView().getVisible()) {
                // The user entered Street View, disable the fullscreen control
                _this5.map.setOptions({
                  fullscreenControl: false
                });
                _this5.showMapHint = false;
              } else {
                // The user exited Street View, enable the fullscreen control
                _this5.map.setOptions({
                  fullscreenControl: false
                });
                _this5.showMapHint = true;
              }
            });
          } catch (error) {
            console.log('error in map street view', error);
          }

          // Initialize the directionsService and directionsRenderer objects after creating the map
          _this5.directionsService = new google.maps.DirectionsService();
          _this5.directionsRenderer = new google.maps.DirectionsRenderer();
          _this5.directionsRenderer.setMap(_this5.map);

          // this.fetchPlaces();
        })["catch"](function (e) {
          console.log('issue with map ', e);
          setTimeout(function () {
            _this5.loadMap();
          }, 1000);
        });
      } else {
        setTimeout(function () {
          _this5.loadMap();
        }, 1000);
      }
    },
    fetchPlaces: function fetchPlaces() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var google, request;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this6.$store.state.searchLocations) {
                _context2.next = 12;
                break;
              }
              _this6.searchLocation = _this6.$store.state.searchLocations;
              _this6.$store.commit('updateSearchLocations', '');
              _this6.loadMap();
              _context2.next = 6;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 2000);
              });
            case 6:
              _this6.$refs.navigateButton.hidden = true;
              google = window.google; // const bounds = this.map.getBounds();
              request = {
                location: _this6.mapOptions.center,
                // bounds: bounds,
                keyword: _this6.searchLocation,
                // Use the keyword from the store
                rankBy: google.maps.places.RankBy.DISTANCE,
                fields: ['name', 'geometry']
              };
              _this6.service = new google.maps.places.PlacesService(_this6.map);
              _this6.service.nearbySearch(request, function (results, status) {
                if (status == google.maps.places.PlacesServiceStatus.OK) {
                  if (results.length > 0) {
                    if (results.length == 1) {
                      _this6.$store.commit('updateSpeakToProcess', 'I found ' + results.length + ' location near you. Would you like me to navigate there?');
                    } else if (results.length > 1) {
                      _this6.$store.commit('updateSpeakToProcess', 'I found ' + results.length + ' locations near you. Please select one for directions or you can zoom out to see more locations.');
                    }
                  }
                  var _loop = function _loop() {
                    var place = results[i];
                    var marker = new google.maps.Marker({
                      map: _this6.map,
                      position: results[i].geometry.location
                    });
                    marker.addListener('click', function () {
                      _this6.infowindow.setContent(place.name || '');
                      _this6.infowindow.open(_this6.map, marker);
                      _this6.selectedLocation = place.geometry.location; // Store the selected location
                      _this6.$refs.navigateButton.hidden = false; // Show the navigate button
                      _this6.infowindow.setContent("<div class=\"infowindow-text\">".concat(place.name || '', "</div>"));
                      _this6.infowindow.open(_this6.map, marker);
                    });
                  };
                  for (var i = 0; i < results.length; i++) {
                    _loop();
                  }
                  _this6.map.setCenter(results[0].geometry.location);
                }
              });
              _this6.searchLocation = '';
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
});